'use client';

import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import EcoStat from 'eco-design-micro/EcoStat';
import { useEffect, useRef } from 'react';

const moduleIdObjA: any = {}; //用于记录只能访问1次
const dataTimeObjA: any = {}; //用于记录进入时间
const dataMessageObjA: any = {}; //用于保存记录的信息
const minTimerValidNumber = 2; //至少停留多少秒才有效
const maxTimerValidNumber = 180; //最多只能停留3分钟;要不然公司的人一直停在本页面一直搞数据
export default function EcoModuleData({ systemTimestamp }: { systemTimestamp: number }) {
    const timeDifferenceRef = useRef(0);
    // 获取本地时间戳
    const getBhTimes = () => {
        return new Date().getTime() - timeDifferenceRef.current;
    };
    // 进行处理
    const itemHandle = (
        elemItem: any,
        { moduleId, moduleId1, moduleId2, status }: { moduleId?: string; moduleId1?: string; moduleId2?: string; status?: 'enter' | 'leave' },
    ) => {
        if (!elemItem) {
            return;
        }
        if (!elemItem.getAttribute) {
            return;
        }

        if (!moduleId) {
            return;
        }
        if (dataTimeObjA[`${moduleId}-status`] === status) {
            // 防止多次触发(已进入或离开时都会触发多次)
            return;
        }
        // 设置模块状态: enter | leave
        if (status === 'enter') {
            dataTimeObjA[`${moduleId}-status`] = 'enter';
        } else if (status === 'leave') {
            dataTimeObjA[`${moduleId}-status`] = 'leave';
        }
        const enterCount = dataTimeObjA[`${moduleId}-count`]; //第几次进入
        if (!enterCount) {
            return;
        }
        // 获取标题
        const title1 = elemItem.getAttribute('data-section-title'); //从 data-title 中直接拿出标题
        let title2 = '';
        if (!title1) {
            const dataClassName = elemItem?.getAttribute('data-section-classname'); //从子项的classname中取出标题
            title2 = dataClassName ? elemItem?.querySelector(dataClassName)?.innerText : '';
        }
        const title = title1 || title2;
        // 将信息保存一份,用于用户一直停在某个模块时,使用定时器回调将信息发回去
        dataMessageObjA[`${moduleId}`] = dataMessageObjA[`${moduleId}`] || {
            moduleId,
            moduleId1,
            moduleId2,
            title,
        };
        const enterTime = dataTimeObjA[`${moduleId}-enter`]; //进入时间
        const leaveTime = dataTimeObjA[`${moduleId}-leave`]; //离开时间
        if (!enterTime) {
            return;
        }
        if (!leaveTime) {
            return;
        }
        // 进入模块;离开模块时才发送数据
        if (status === 'enter') {
            // EcoStat.pageModuleCreate({
            //     moduleId,
            //     enterCount,
            //     title,
            //     enterTime,
            // });
        }

        // 离开时间小于进入时间,说明它是2次进入
        if (leaveTime < enterTime) {
            return;
        }
        const duration1 = leaveTime - enterTime;
        const duration2 = (duration1 / 1000).toFixed(2);
        const duration = Number(duration2); //停留了多少秒

        // 要发送的数据;只发送大于1s的数据;避免划动过快时产生太多数据
        if (status === 'leave' && duration >= minTimerValidNumber && duration < maxTimerValidNumber) {
            EcoStat.pageModuleCreate({
                moduleId,
                moduleId1,
                moduleId2,
                enterCount,
                enterTime,
                leaveTime,
                duration, //停留时间
                title,
            });
            // 将进入时间和离开时间清空
            dataTimeObjA[`${moduleId}-enter`] = null;
            dataTimeObjA[`${moduleId}-leave`] = null;
            //delete dataTimeObjA[`${moduleId}-enter`];
            //delete dataTimeObjA[`${moduleId}-leave`];
        }
    };
    // 监听单个
    const initGtmItemHandle = (elem: any, { moduleId, moduleId1, moduleId2 }: any) => {
        const observer = new IntersectionObserver(
            (elemA: any) => {
                const elemB = elemA[0];

                if (elemB.isIntersecting) {
                    // 进入可视区
                    dataTimeObjA[`${moduleId}-count`] = (dataTimeObjA[`${moduleId}-count`] || 0) + 1; //第几次进入
                    dataTimeObjA[`${moduleId}-enter`] = getBhTimes(); // 记录进入可视区的时间
                    itemHandle(elem, { moduleId, moduleId1, moduleId2, status: 'enter' });
                } else {
                    // 必须进入过才算
                    if (dataTimeObjA[`${moduleId}-enter`]) {
                        // 离开可视区
                        dataTimeObjA[`${moduleId}-leave`] = getBhTimes(); // 记录离开可视区的时间
                        itemHandle(elem, { moduleId, moduleId1, moduleId2, status: 'leave' });
                    }
                }
            },
            { threshold: 0.1 },
        ); // 触发的阈值（0.1 表示 10% 可见时触发）
        observer.observe(elem);
    };
    // 开始
    const initGtmModuleHandle = () => {
        const elemList = document.querySelectorAll('.GtmModuleData-section'); //要监听的元素列表
        for (let i = 0; i < elemList.length; i++) {
            const elemItem = elemList[i];
            if (!elemItem) {
                continue;
            }
            const moduleIdA = elemItem.getAttribute('data-section-id') || ''; //主ID
            const moduleIdB = elemItem.getAttribute('data-section-id2') || ''; //辅助ID(同一个组件,一个页面可能用了多次)
            const moduleId = `${moduleIdA}${moduleIdB}`;
            // 必须要有-模块ID
            if (!moduleId) {
                continue;
            }
            // 模块ID-只能监听1次
            if (moduleIdObjA[moduleId]) {
                continue;
            }
            initGtmItemHandle(elemItem, {
                moduleId,
                moduleId1: moduleIdA,
                moduleId2: moduleIdB,
            });
            moduleIdObjA[moduleId] = true;
        }
    };
    // 执行
    const setTimeoutHandleForLeaveB = async (initSendFlag: boolean) => {
        for (const moduleId in dataMessageObjA) {
            // 必须是有进入时间
            const enterTime = dataTimeObjA[`${moduleId}-enter`];
            const statusA = dataTimeObjA[`${moduleId}-status`];
            const messageA = dataMessageObjA[moduleId];
            if (!messageA) {
                continue;
            }
            if (!enterTime) {
                continue;
            }
            // 状态必须是进入;否则划得过快时,会将所有的都传到后台
            if (statusA !== 'enter') {
                continue;
            }
            const enterCount = dataTimeObjA[`${moduleId}-count`];
            if (!enterCount) {
                continue;
            }
            const leaveTime = getBhTimes();
            const duration1 = leaveTime - enterTime;
            const duration2 = (duration1 / 1000).toFixed(2);
            const duration = Number(duration2); //停留了多少秒
            const isPassDurationA = duration < minTimerValidNumber || duration > maxTimerValidNumber; //不允许通过
            const isPassDurationB = initSendFlag || !isPassDurationA; //允许刚进入时强制发送
            if (!isPassDurationB) {
                continue;
            }

            EcoStat.pageModuleCreate({
                moduleId,
                moduleId1: messageA.moduleId1,
                moduleId2: messageA.moduleId2,
                enterCount,
                enterTime,
                leaveTime,
                duration: duration || 1, //停留时间
                title: messageA.title,
            });
        }
    };

    useEffect(() => {
        const __init_handle = () => {
            const initTimesAHandle = (systemTimestampA: number) => {
                const systemTimestampB = systemTimestampA || Date.now();
                const localTimestamp = Date.now(); //本地时间戳
                timeDifferenceRef.current = localTimestamp - systemTimestampB || 0;
            };
            initTimesAHandle(systemTimestamp);
            initGtmModuleHandle();
            setTimeout(() => {
                initGtmModuleHandle();
            }, 1500);
            setTimeout(() => {
                initGtmModuleHandle();
            }, 3500);
            // 执行监听;用于切到tab时没有监听到的元素
            EcoDesignEventsBus.on('GtmModuleData-start', () => {
                initGtmModuleHandle();
            });
            EcoDesignEventsBus.on('GtmModuleData-send', (initSendFlag?: boolean) => {
                setTimeoutHandleForLeaveB(initSendFlag || false);
            });
        };
        try {
            __init_handle();
        } catch (error) {}
    }, []);
    return null;
}
